import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getAllPricingPlans, getPriceById } from '../query-fn/pricing';

export const pricingQueryKeys = createQueryKeys('pricing', {
  plans: {
    queryKey: null,
    queryFn: (ctx) => getAllPricingPlans(ctx)
  },
  priceById: (priceId: string) => ({
    queryKey: [priceId],
    queryFn: (ctx) => getPriceById(priceId, ctx)
  })
});
